<template>
  <div>
    <loading v-if="loading" />
    <div v-else>
      <div class="p-6" v-if="activity">
        <h2 class="mb-6 leading-tight text-center">{{ activity.title }}</h2>
        <div
          class="max-w-md mx-auto mt-3 text-center border border-gray-300 p-4"
        >
          <h3 class="mb-0 leading-tight text-center">
            {{ $t("general.period.month") }}
          </h3>
          <p class="text-sm">
            {{ entryStatsMonth.total }} {{ $t("activities.times_checked") }}
          </p>
          <statistic-entries
            :entries="entryStatsMonth.grouped"
            :range="30"
            type="day"
            key="month"
          />
        </div>
        <div
          class="max-w-md mx-auto mt-3 text-center border border-gray-300 p-4"
        >
          <h3 class="mb-0 leading-tight text-center">
            {{ $t("general.period.year") }}
          </h3>
          <p class="text-sm">
            {{ entryStatsYear.total }} {{ $t("activities.times_checked") }}
          </p>
          <statistic-entries
            :entries="entryStatsYear.grouped"
            :range="365"
            type="week"
            key="year"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Activity } from "@/modules/activities/viewmodels/Activity";
import DateMixin from "@/mixins/DateMixin";

const Tab = require("@/modules/core/components/Tab.vue").default;
const Tabs = require("@/modules/core/components/Tabs.vue").default;
const ProgressBar = require("@/modules/core/components/ProgressBar.vue")
  .default;
const ActivityWeek = require("@/modules/activities/components/ActivityWeek.vue")
  .default;
const StatisticEntries = require("@/modules/dashboard/components/StatisticEntries.vue")
  .default;

export default {
  name: "ActivityDetailSite",
  mixins: [DateMixin],
  data() {
    return {
      sending: false,
      entryStatsMonth: [],
      entryStatsYear: [],
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  components: {
    StatisticEntries,
  },
  methods: {
    async getActivity() {
      return await this.$store.getters["activity/api"].Show(this.id);
    },
    open(link) {
      this.area = link;
    },
    async deleteCustomActivity() {
      this.$store.getters["activity/api"]
        .Destroy(this.id)
        .then(() => {
          this.goTo("/activities");
        })
        .catch((e) => {
          this.popup({
            type: "alert",
            title: this.$t("general.error"),
            text: this.$t("activities.error_delete_message"),
          });
        });
    },
  },
  computed: {
    activity() {
      return this.$store.getters["activity/activity"](this.id);
    },
  },
  async created() {
    await this.getActivity();
    this.entryStatsMonth = await this.$store.getters[
      "activityentry/api"
    ].Custom.AllActivityStats(this.id, { range: 30, type: "daily" });
    this.entryStatsYear = await this.$store.getters[
      "activityentry/api"
    ].Custom.AllActivityStats(this.id, { range: 365, type: "weekly" });

    this.loading = false;
  },
};
</script>
